import type { Action } from '../common/actions'
import { isType } from '../common/actions'
import {
    ClearDownloaderState,
    SetClickedLinkStatus,
    SetDownloaderModalStatus,
    StartPaginatedDownloadFlow,
} from './actions'

export type ModalStatus = 'off' | 'min' | 'max'
export type DownloaderPage = {
    files: FileID[]
    fileSize: number
    clicked: boolean
    name: string
}

export type DownloaderState = {
    jobID: JobID
    convert: boolean
    subrevisions: boolean
    modalStatus: ModalStatus
    count: number
    size: number
    pages: DownloaderPage[]
    zipFileName: string
    isFromTrash: boolean
}

const initialState: DownloaderState = {
    jobID: '',
    convert: false,
    subrevisions: false,
    modalStatus: 'off',
    count: 0,
    size: 0,
    pages: [],
    zipFileName: '',
    isFromTrash: false,
}

export function downloaderReducer(
    state: DownloaderState = initialState,
    action: Action,
): DownloaderState {
    if (isType(action, StartPaginatedDownloadFlow)) {
        return { ...state, ...action.payload }
    }
    if (isType(action, SetDownloaderModalStatus)) {
        return { ...state, modalStatus: action.payload }
    }
    if (isType(action, SetClickedLinkStatus)) {
        return {
            ...state,
            pages: state.pages.map((page, id) => {
                if (id === action.payload) {
                    return {
                        ...page,
                        clicked: true,
                    }
                }

                return page
            }),
        }
    }
    if (isType(action, ClearDownloaderState)) {
        return initialState
    }

    return state
}

export const downloaderReducerMapObj = {
    downloader: downloaderReducer,
}

export type StateWithDownloader = StateOfReducerMapObj<
    typeof downloaderReducerMapObj
>
